<div class="modal-header">
    <h5 class="modal-title">Impact Append Assess</h5>
    <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
        aria-hidden="true"></button>
</div>
<div class="modal-body">
    <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
    <div class="row align-items-end">
        <div class="col-lg-3">
            <div class="form-group">
                <div class="left inline control-label mb-1">Published From</div>
                <div class="input-group input-group-sm"
                    *ngIf="impactAssessmentFilter && impactAssessmentFilter.fromDate">
                    <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
                        class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
                        [(ngModel)]="impactAssessmentFilter.fromDate" readonly>
                    <div class="input-group-append">
                        <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
                    </div>
                </div>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="form-group">
                <div class="left inline control-label d-none d-sm-block mb-1">Published Until</div>
                <div class="input-group input-group-sm"
                    *ngIf="impactAssessmentFilter && impactAssessmentFilter.fromDate">
                    <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
                        class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
                        [(ngModel)]="impactAssessmentFilter.toDate" readonly>
                    <div class="input-group-append">
                        <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
                    </div>
                </div>
                <mat-datepicker #toPicker></mat-datepicker>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="form-group">
                <div class="left inline control-label mb-1">Key Words</div>
                <mat-chip-grid #keywordsList>
                    <mat-chip-row *ngFor="let sQuery of impactAssessmentFilter.searchQuery" [selectable]="selectable"
                        [removable]="removable" (removed)="removeKeywords(sQuery)">
                        {{sQuery}}
                        <mat-icon matChipRemove *ngIf="removable">clear</mat-icon>
                    </mat-chip-row>
                    <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput
                        [formControl]="keyCtrl" [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="addKeywords($event)">
                </mat-chip-grid>
                <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selectedKeywords($event)">
                    <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
                        {{fK}}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
        <div class="col-md-2 pt-2">
            <button class="btn bg-g-lightGreen btn-sm mr-2" (click)="keywordSearch()">Submit</button>
            <button class="btn bg-g-lightGreen btn-sm" (click)="resetKeyWords()">Reset</button>
        </div>
        <div class="col-sm-12 text-left">
            <div class="text-blue" *ngIf="(impactAssessmentList && (impactAssessmentList.length>0))">
                <div>{{endIndex}} out of {{totalCount}}</div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="table-responsive box-shadow">
                <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
                <table class="table table-fixed mb-0 policy-table">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 5%;"></th>
                            <th class="text-center" style="width: 15%;" (click)="sortImpactAssessment('updatedDB_Id')">
                                Id
                                <i class="fa"
                                    [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'updatedDB_Id' && !impactAssessmentFilter.IsDesc),
                  'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'updatedDB_Id' && impactAssessmentFilter.IsDesc) }"
                                    aria-hidden="true">
                                </i>
                            </th>
                            <th class="text-center" style="width: 15%;" (click)="sortImpactAssessment('Regulator')">
                                Regulator
                                <i class="fa"
                                    [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Regulator' && !impactAssessmentFilter.IsDesc),
                  'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Regulator' && impactAssessmentFilter.IsDesc) }"
                                    aria-hidden="true">
                                </i>
                            </th>
                            <th class="text-center" style="width: 50%;" (click)="sortImpactAssessment('Title')">Title
                                <i class="fa"
                                    [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'Title' && !impactAssessmentFilter.IsDesc),
                  'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'Title' && impactAssessmentFilter.IsDesc) }"
                                    aria-hidden="true">
                                </i>
                            </th>
                            <th class="width-3pr text-center" style="width: 15%;"
                                (click)="sortImpactAssessment('updatedDB_Date')">Publish Date
                                <i class="fa"
                                    [ngClass]="{'fa-sort-amount-asc': (impactAssessmentFilter.SortKey === 'updatedDB_Date' && !impactAssessmentFilter.IsDesc),
                  'fa-sort-amount-desc': (impactAssessmentFilter.SortKey === 'updatedDB_Date' && impactAssessmentFilter.IsDesc) }"
                                    aria-hidden="true">
                                </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="(impactAssessmentList && (impactAssessmentList.length > 0))" style="max-height: 500px;">
                        <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="30"
                            (scrolledIndexChange)="handler($event)" style="height: 500px;"
                            *ngIf="impactAssessmentList.length > 0">
                            <div *cdkVirtualFor="let item of impactAssessmentList; let i = index">
                                <tr (click)="selectedItemId = item.id">
                                    <td class="text-center" scope="row" style="width: 5%;">
                                        <i class="fa fa-square-o icon-font"
                                            (click)="selectItem('Checked', item.id, item.updatedDBId)"
                                            *ngIf="!getSelectedItems(item.id)" aria-hidden="true"></i>
                                        <i class="fa fa-check-square icon-font"
                                            (click)="selectItem('UnChecked', item.id, item.updatedDBId)"
                                            *ngIf="getSelectedItems(item.id)" aria-hidden="true"></i>
                                    </td>
                                    <td class="text-center tabel-td-scroll" style="width: 15%;" scope="row">
                                        <span *ngIf="item.isMerged">
                                            <a
                                                [routerLink]="['/impact-assessment/details/impact/',templateNo, item.id]">
                                                <div *ngFor="let option of item.merged_Id|stringtoarr;">
                                                    {{option}}</div>
                                            </a>
                                        </span>
                                        <span *ngIf="!item.isMerged">
                                            <a
                                                [routerLink]="['/impact-assessment/details/impact/',templateNo, item.id]">{{item.updatedDBId}}</a>
                                        </span>

                                    </td>
                                    <td class="text-center tabel-td-scroll" style="width: 15%;" scope="row">
                                        {{item.regulator}}
                                    </td>
                                    <td class="text-center tabel-td-scroll" style="width: 50%;" scope="row">
                                        {{item.title}}</td>
                                    <td class="text-center tabel-td-scroll" style="width: 15%;" scope="row">
                                        {{item.publishDate | date:'dd-MMM-yyyy'}}</td>
                                </tr>
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-sm" (click)="cancelModal()">Cancel</button>
    <button class="btn btn-sm" (click)="closeModal()">Append</button>
</div>